export default "__VITE_ASSET__CNdUof_T__"